export default "__VITE_ASSET__990650da__"